import { inject } from '@vercel/analytics';

inject();
